import React from 'react';
import { motion } from 'framer-motion';
import { Search, XCircle, Folder, Video, Mic, Radio, Play, TrendingUp, Settings, Star, Music, Headphones, Zap, Camera, Tv, User, Briefcase, CheckCircle2, ArrowRight } from 'lucide-react';
import { LineChart, Line, ResponsiveContainer, Tooltip } from 'recharts';
const royaltyData = [{
  name: 'W1',
  value: 2400
}, {
  name: 'W2',
  value: 1398
}, {
  name: 'W3',
  value: 9800
}, {
  name: 'W4',
  value: 3908
}, {
  name: 'W5',
  value: 4800
}, {
  name: 'W6',
  value: 3800
}, {
  name: 'W7',
  value: 4300
}];
interface HomeProps {
  auditQuery: string;
  setAuditQuery: (val: string) => void;
  auditResult: any;
  runAudit: () => void;
  setAuditResult: (val: any) => void;
  isLive: boolean;
  setIsLive: (val: boolean) => void;
  setActiveSection: (val: string) => void;
}
export function Home({
  auditQuery,
  setAuditQuery,
  auditResult,
  runAudit,
  setAuditResult,
  isLive,
  setIsLive,
  setActiveSection
}: HomeProps) {
  return <>
      {/* Hero Section */}
      <section className="relative pt-32 md:pt-48 pb-20 md:pb-32 px-6 overflow-hidden" data-id="element-191">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full pointer-events-none" data-id="element-192">
          <div className="absolute top-0 left-1/4 w-[500px] h-[500px] bg-[#FFD700]/10 blur-[120px] rounded-full" data-id="element-193"></div>
          <div className="absolute bottom-0 right-1/4 w-[400px] h-[400px] bg-red-600/10 blur-[100px] rounded-full" data-id="element-194"></div>
        </div>
        <div className="max-w-5xl mx-auto text-center relative z-10" data-id="element-195">
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="font-['Archivo_Black'] text-4xl md:text-6xl lg:text-7xl uppercase leading-[0.9] mb-6 tracking-tighter" data-id="element-196">
            Build Your Brand.
            <br data-id="element-197" />
            <span className="text-[#FFD700]" data-id="element-198">Own Your Audience.</span>
            <br data-id="element-199" />
            Monetize Content.
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.1
        }} className="text-lg md:text-xl text-gray-400 max-w-3xl mx-auto mb-10 font-medium leading-relaxed" data-id="element-200">
            Professional infrastructure for influencers, artists, and creators.{' '}
            <br className="hidden md:block" data-id="element-201" />
            Stop renting your audience on social media.
          </motion.p>
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.2
        }} className="flex flex-col sm:flex-row items-center justify-center gap-4 md:gap-6" data-id="element-202">
            <button onClick={() => setActiveSection('websites')} className="w-full sm:w-auto bg-[#FFD700] text-black px-8 md:px-10 py-4 md:py-5 rounded font-bold uppercase tracking-widest hover:bg-white transition-all text-base md:text-lg shadow-[0_0_30px_rgba(255,215,0,0.2)]" data-id="element-203">
              Start My Site
            </button>
            <button className="w-full sm:w-auto border-2 border-[#FF0000] text-[#FF0000] px-8 md:px-10 py-4 md:py-5 rounded font-bold uppercase tracking-widest hover:bg-[#FF0000] hover:text-white transition-all text-base md:text-lg shadow-[0_0_30px_rgba(255,0,0,0.2)]" data-id="element-204">
              Take the Free Creator Audit
            </button>
          </motion.div>

          {/* Brand Audit Search */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.35
        }} className="mt-8 md:mt-12 max-w-2xl mx-auto" data-id="element-205">
            <p className="text-[10px] md:text-xs font-bold text-gray-500 uppercase tracking-widest text-center mb-4" data-id="element-206">
              Quick Brand Audit — Enter your website or social handle
            </p>
            <div className="flex flex-col sm:flex-row bg-[#1A1A1A] border border-white/10 rounded-xl overflow-hidden shadow-2xl" data-id="element-207">
              <div className="flex-1 flex items-center pl-5 py-3 sm:py-0" data-id="element-208">
                <Search size={20} className="text-gray-600 shrink-0" data-id="element-209" />
                <input type="text" value={auditQuery} onChange={e => {
                setAuditQuery(e.target.value);
                setAuditResult(null);
              }} onKeyDown={e => e.key === 'Enter' && runAudit()} placeholder="e.g. @artistname or yourdomain.com" className="w-full bg-transparent px-4 py-3 text-white placeholder-gray-600 focus:outline-none font-medium text-sm" data-id="element-210" />
              </div>
              <button onClick={runAudit} className="bg-[#FFD700] text-black px-8 py-4 sm:py-0 font-bold text-xs uppercase tracking-widest hover:bg-white transition-all whitespace-nowrap" data-id="element-211">
                Audit Now
              </button>
            </div>
            {auditResult && <motion.div initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} className="mt-6 bg-[#1A1A1A] border border-white/5 rounded-xl p-6 text-left" data-id="element-212">
                <div className="flex items-center justify-between mb-6" data-id="element-213">
                  <div data-id="element-214">
                    <p className="text-[10px] font-bold text-gray-500 uppercase tracking-widest" data-id="element-215">
                      Brand Health Score
                    </p>
                    <p className="text-4xl font-['Archivo_Black'] text-[#FF0000]" data-id="element-216">
                      {auditResult.score}/100
                    </p>
                  </div>
                  <div className="text-right" data-id="element-217">
                    <span className="px-3 py-1 bg-[#FF0000]/10 border border-[#FF0000]/20 rounded text-[10px] font-bold text-[#FF0000] uppercase tracking-widest" data-id="element-218">
                      Needs Improvement
                    </span>
                  </div>
                </div>
                <div className="space-y-3" data-id="element-219">
                  {auditResult.issues.map((issue: string, i: number) => <div key={i} className="flex items-start gap-3 text-sm" data-id="element-220">
                      <XCircle size={16} className="text-[#FF0000] shrink-0 mt-0.5" data-id="element-221" />
                      <span className="text-gray-400" data-id="element-222">{issue}</span>
                    </div>)}
                </div>
                <button className="mt-6 w-full bg-[#FFD700] text-black py-3 rounded font-bold text-xs uppercase tracking-widest hover:bg-white transition-all" data-id="element-223">
                  Get Your Custom Fix Plan →
                </button>
              </motion.div>}
          </motion.div>
        </div>
      </section>

      {/* Celebrity Dashboard Preview */}
      <section className="py-24 px-6 bg-[#1A1A1A]/30" data-id="element-224">
        <div className="max-w-7xl mx-auto" data-id="element-225">
          <div className="text-center mb-16" data-id="element-226">
            <h2 className="font-['Archivo_Black'] text-3xl md:text-5xl uppercase mb-4" data-id="element-227">
              The Celebrity Dashboard
            </h2>
            <p className="text-gray-500 font-bold uppercase tracking-widest" data-id="element-228">
              Your entire empire in one high-end view
            </p>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-229">
            {/* Media Vault */}
            <div className="bg-[#1A1A1A] border border-white/5 rounded-2xl p-8 shadow-2xl" data-id="element-230">
              <div className="flex items-center justify-between mb-8" data-id="element-231">
                <div className="flex items-center gap-3" data-id="element-232">
                  <Folder className="text-[#FFD700]" size={24} data-id="element-233" />
                  <h3 className="font-bold uppercase tracking-wider" data-id="element-234">
                    Media Vault
                  </h3>
                </div>
                <span className="text-[10px] font-bold text-gray-500 uppercase tracking-widest" data-id="element-235">
                  1.2 TB Used
                </span>
              </div>
              <div className="space-y-4" data-id="element-236">
                {[{
                name: 'Latest Music Video',
                type: 'Video',
                size: '2.4 GB',
                icon: Video
              }, {
                name: 'Podcast Masters',
                type: 'Audio',
                size: '840 MB',
                icon: Mic
              }, {
                name: 'Press Kit 2024',
                type: 'Folder',
                size: '12 Items',
                icon: Folder
              }].map((item, i) => <div key={i} className="flex items-center justify-between p-4 bg-black/40 rounded-xl border border-white/5 hover:border-[#FFD700]/30 transition-colors cursor-pointer group" data-id="element-237">
                    <div className="flex items-center gap-4" data-id="element-238">
                      <div className="p-2 bg-white/5 rounded-lg group-hover:bg-[#FFD700]/10 transition-colors" data-id="element-239">
                        <item.icon size={18} className="text-gray-400 group-hover:text-[#FFD700]" data-id="element-240" />
                      </div>
                      <div data-id="element-241">
                        <p className="text-sm font-bold" data-id="element-242">{item.name}</p>
                        <p className="text-[10px] text-gray-500 font-bold uppercase" data-id="element-243">
                          {item.type}
                        </p>
                      </div>
                    </div>
                    <span className="text-[10px] font-bold text-gray-500" data-id="element-244">
                      {item.size}
                    </span>
                  </div>)}
              </div>
            </div>

            {/* Streaming Center */}
            <div className="bg-[#1A1A1A] border border-white/5 rounded-2xl p-8 shadow-2xl flex flex-col" data-id="element-245">
              <div className="flex items-center justify-between mb-8" data-id="element-246">
                <div className="flex items-center gap-3" data-id="element-247">
                  <Radio className="text-[#FF0000]" size={24} data-id="element-248" />
                  <h3 className="font-bold uppercase tracking-wider" data-id="element-249">
                    Streaming Center
                  </h3>
                </div>
                <div className="flex items-center gap-3" data-id="element-250">
                  <span className="text-[10px] font-bold text-gray-500 uppercase tracking-widest" data-id="element-251">
                    Live Status
                  </span>
                  <button onClick={() => setIsLive(!isLive)} className={`w-10 h-5 rounded-full relative transition-colors ${isLive ? 'bg-[#FF0000]' : 'bg-gray-800'}`} data-id="element-252">
                    <motion.div animate={{
                    x: isLive ? 22 : 2
                  }} className="absolute top-1 left-0 w-3 h-3 bg-white rounded-full" data-id="element-253" />
                  </button>
                </div>
              </div>
              <div className="flex-1 flex flex-col justify-center items-center text-center py-8" data-id="element-254">
                <div className={`w-20 h-20 rounded-full flex items-center justify-center mb-6 border transition-all ${isLive ? 'bg-[#FF0000]/20 border-[#FF0000]/30 shadow-[0_0_30px_rgba(255,0,0,0.2)]' : 'bg-gray-900 border-white/5'}`} data-id="element-255">
                  <Play size={32} className={isLive ? 'text-[#FF0000] ml-1' : 'text-gray-700 ml-1'} data-id="element-256" />
                </div>
                <h4 className="text-xl font-bold mb-2" data-id="element-257">
                  {isLive ? 'Wowza Integration Active' : 'Stream Offline'}
                </h4>
                <p className="text-sm text-gray-500 mb-8" data-id="element-258">
                  {isLive ? 'Broadcasting to 12.4k viewers' : 'Ready to go live'}
                </p>
                <div className="w-full grid grid-cols-2 gap-4" data-id="element-259">
                  <button className="py-3 bg-white/5 rounded-lg text-[10px] font-bold uppercase tracking-widest border border-white/5 hover:bg-white/10 transition-colors" data-id="element-260">
                    VOD Library
                  </button>
                  <button className="py-3 bg-white/5 rounded-lg text-[10px] font-bold uppercase tracking-widest border border-white/5 hover:bg-white/10 transition-colors" data-id="element-261">
                    Stream Settings
                  </button>
                </div>
              </div>
            </div>

            {/* Royalty Tracker */}
            <div className="bg-[#1A1A1A] border border-white/5 rounded-2xl p-8 shadow-2xl" data-id="element-262">
              <div className="flex items-center justify-between mb-8" data-id="element-263">
                <div className="flex items-center gap-3" data-id="element-264">
                  <TrendingUp className="text-emerald-500" size={24} data-id="element-265" />
                  <h3 className="font-bold uppercase tracking-wider" data-id="element-266">
                    Royalty Tracker
                  </h3>
                </div>
                <span className="text-[10px] font-bold text-emerald-500 uppercase tracking-widest" data-id="element-267">
                  +24% Growth
                </span>
              </div>
              <div className="mb-8" data-id="element-268">
                <p className="text-[10px] font-bold text-gray-500 uppercase tracking-widest mb-1" data-id="element-269">
                  Monthly Content Revenue
                </p>
                <h4 className="text-4xl font-['Archivo_Black'] tracking-tighter" data-id="element-270">
                  $12,840.00
                </h4>
              </div>
              <div className="h-[120px] w-full" data-id="element-271">
                <ResponsiveContainer width="100%" height="100%" data-id="element-272">
                  <LineChart data={royaltyData} data-id="element-273">
                    <Line type="monotone" dataKey="value" stroke="#10B981" strokeWidth={3} dot={false} data-id="element-274" />
                    <Tooltip contentStyle={{
                    backgroundColor: '#0D0D0D',
                    border: 'none',
                    borderRadius: '8px',
                    fontSize: '10px'
                  }} data-id="element-275" />
                  </LineChart>
                </ResponsiveContainer>
              </div>
              <div className="mt-8 grid grid-cols-2 gap-4" data-id="element-276">
                <button className="flex items-center justify-center gap-2 py-3 bg-[#FFD700] text-black rounded-lg text-[10px] font-bold uppercase tracking-widest hover:bg-white transition-colors" data-id="element-277">
                  <Settings size={14} data-id="element-278" /> Manage Hosting
                </button>
                <button className="flex items-center justify-center gap-2 py-3 bg-white/5 rounded-lg text-[10px] font-bold uppercase tracking-widest border border-white/5 hover:bg-white/10 transition-colors" data-id="element-279">
                  Update Tour Dates
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Section 2: Who We Help */}
      <section className="py-24 px-6" data-id="element-280">
        <div className="max-w-7xl mx-auto" data-id="element-281">
          <div className="text-center mb-16" data-id="element-282">
            <h2 className="font-['Archivo_Black'] text-3xl md:text-5xl uppercase mb-4" data-id="element-283">
              Who We Help
            </h2>
            <p className="text-gray-500 font-bold uppercase tracking-widest" data-id="element-284">
              Tailored infrastructure for the elite creator economy
            </p>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-6" data-id="element-285">
            {[{
            name: 'Influencers',
            icon: Star
          }, {
            name: 'Musicians',
            icon: Music
          }, {
            name: 'DJs',
            icon: Headphones
          }, {
            name: 'Podcasters',
            icon: Mic
          }, {
            name: 'Social Marketers',
            icon: Zap
          }, {
            name: 'Content Creators',
            icon: Camera
          }, {
            name: 'Streamers',
            icon: Tv
          }, {
            name: 'Public Figures',
            icon: User
          }, {
            name: 'Entertainment Brands',
            icon: Briefcase
          }].map((audience, i) => <motion.div key={i} whileHover={{
            y: -5
          }} className="bg-[#1A1A1A] border border-white/5 p-6 rounded-2xl flex flex-col items-center text-center gap-4 group hover:border-[#FFD700]/30 transition-all" data-id="element-286">
                <div className="w-12 h-12 bg-white/5 rounded-xl flex items-center justify-center group-hover:bg-[#FFD700]/10 transition-colors" data-id="element-287">
                  <audience.icon className="text-gray-400 group-hover:text-[#FFD700]" size={24} data-id="element-288" />
                </div>
                <span className="text-xs font-bold uppercase tracking-wider" data-id="element-289">
                  {audience.name}
                </span>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* Section 3: Ownership Gap */}
      <section className="py-24 px-6 bg-[#1A1A1A]/30" data-id="element-290">
        <div className="max-w-7xl mx-auto" data-id="element-291">
          <div className="text-center mb-16" data-id="element-292">
            <h2 className="font-['Archivo_Black'] text-3xl md:text-5xl uppercase mb-4" data-id="element-293">
              The Ownership Gap
            </h2>
            <p className="text-gray-500 font-bold uppercase tracking-widest" data-id="element-294">
              Why a website beats social media every time
            </p>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-295">
            <div className="bg-red-500/5 border border-red-500/10 rounded-3xl p-8 md:p-12" data-id="element-296">
              <div className="flex items-center gap-4 mb-8" data-id="element-297">
                <div className="w-12 h-12 bg-red-500/10 rounded-xl flex items-center justify-center" data-id="element-298">
                  <XCircle className="text-red-500" size={28} data-id="element-299" />
                </div>
                <h3 className="font-['Archivo_Black'] text-2xl uppercase" data-id="element-300">
                  Social Media Only
                </h3>
              </div>
              <ul className="space-y-6" data-id="element-301">
                {[{
                title: 'Limited Control',
                desc: 'You follow their rules, their layout, and their restrictions.'
              }, {
                title: 'Algorithm Dependence',
                desc: 'One update can wipe out your reach overnight.'
              }, {
                title: 'Links Scattered Everywhere',
                desc: 'Bio links are messy and lose potential conversions.'
              }, {
                title: 'No Ownership of Audience',
                desc: "You don't own your followers' data or contact info."
              }].map((item, i) => <li key={i} className="flex gap-4" data-id="element-302">
                    <div className="mt-1.5 w-1.5 h-1.5 rounded-full bg-red-500 shrink-0" data-id="element-303" />
                    <div data-id="element-304">
                      <p className="font-bold uppercase text-sm mb-1" data-id="element-305">
                        {item.title}
                      </p>
                      <p className="text-gray-500 text-sm leading-relaxed" data-id="element-306">
                        {item.desc}
                      </p>
                    </div>
                  </li>)}
              </ul>
            </div>
            <div className="bg-[#FFD700]/5 border border-[#FFD700]/10 rounded-3xl p-8 md:p-12 shadow-[0_0_50px_rgba(255,215,0,0.05)]" data-id="element-307">
              <div className="flex items-center gap-4 mb-8" data-id="element-308">
                <div className="w-12 h-12 bg-[#FFD700]/10 rounded-xl flex items-center justify-center" data-id="element-309">
                  <CheckCircle2 className="text-[#FFD700]" size={28} data-id="element-310" />
                </div>
                <h3 className="font-['Archivo_Black'] text-2xl uppercase" data-id="element-311">
                  HipHopServers Website
                </h3>
              </div>
              <ul className="space-y-6" data-id="element-312">
                {[{
                title: 'Centralized Content',
                desc: 'Your music, videos, and merch all in one professional hub.'
              }, {
                title: 'Own Your Brand & Audience',
                desc: 'Direct access to fan emails and data with zero filters.'
              }, {
                title: 'Monetization Tools',
                desc: 'Keep 100% of your revenue with built-in e-commerce.'
              }, {
                title: 'Professional Appearance',
                desc: 'Enterprise-grade design that commands industry respect.'
              }, {
                title: 'Search Engine Visibility',
                desc: 'Get found on Google, not just within a social app.'
              }, {
                title: 'One Link For Everything',
                desc: 'A single, powerful destination for your entire empire.'
              }].map((item, i) => <li key={i} className="flex gap-4" data-id="element-313">
                    <div className="mt-1.5 w-1.5 h-1.5 rounded-full bg-[#FFD700] shrink-0" data-id="element-314" />
                    <div data-id="element-315">
                      <p className="font-bold uppercase text-sm mb-1 text-white" data-id="element-316">
                        {item.title}
                      </p>
                      <p className="text-gray-400 text-sm leading-relaxed" data-id="element-317">
                        {item.desc}
                      </p>
                    </div>
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Section 5: Showcase */}
      <section className="py-24 px-6" data-id="element-318">
        <div className="max-w-7xl mx-auto" data-id="element-319">
          <div className="text-center mb-16" data-id="element-320">
            <h2 className="font-['Archivo_Black'] text-3xl md:text-5xl uppercase mb-4" data-id="element-321">
              Creator Showcase
            </h2>
            <p className="text-gray-500 font-bold uppercase tracking-widest" data-id="element-322">
              See how the elite build their online presence
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-323">
            {[{
            title: 'Music Artist Page',
            desc: 'Streaming integration, tour dates, and merch store.',
            image: 'https://images.unsplash.com/photo-1514525253361-bee8718a74a2?auto=format&fit=crop&q=80&w=800',
            features: ['Spotify Sync', 'Ticket Sales', 'VIP Access']
          }, {
            title: 'Podcast Hub',
            desc: 'Episode library, guest booking, and listener analytics.',
            image: 'https://images.unsplash.com/photo-1590602847861-f357a9332bbc?auto=format&fit=crop&q=80&w=800',
            features: ['RSS Feed Auto-Sync', 'Guest Forms', 'Ad Management']
          }, {
            title: 'Influencer Landing Page',
            desc: 'Brand deals, media kit, and social feed aggregation.',
            image: 'https://images.unsplash.com/photo-1511671782779-c97d3d27a1d4?auto=format&fit=crop&q=80&w=800',
            features: ['Live Social Feed', 'Media Kit PDF', 'Brand Inquiries']
          }, {
            title: 'Public Figure / Speaker',
            desc: 'Booking calendar, press mentions, and keynote library.',
            image: 'https://images.unsplash.com/photo-1475721027785-f74eccf877e2?auto=format&fit=crop&q=80&w=800',
            features: ['Calendar Sync', 'Speaker Reel', 'Press Mentions']
          }].map((showcase, i) => <motion.div key={i} whileHover={{
            y: -10
          }} className="group bg-[#1A1A1A] border border-white/5 rounded-3xl overflow-hidden hover:border-[#FFD700]/30 transition-all" data-id="element-324">
                <div className="aspect-video relative overflow-hidden" data-id="element-325">
                  <img src={showcase.image} alt={showcase.title} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" data-id="element-326" />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0D0D0D] to-transparent opacity-60" data-id="element-327" />
                  <div className="absolute bottom-6 left-6 right-6" data-id="element-328">
                    <div className="flex gap-2 mb-3" data-id="element-329">
                      {showcase.features.map((f, j) => <span key={j} className="px-2 py-1 bg-[#FFD700]/10 border border-[#FFD700]/20 rounded text-[10px] font-bold text-[#FFD700] uppercase tracking-widest" data-id="element-330">
                          {f}
                        </span>)}
                    </div>
                    <h3 className="font-['Archivo_Black'] text-2xl uppercase" data-id="element-331">
                      {showcase.title}
                    </h3>
                  </div>
                </div>
                <div className="p-8" data-id="element-332">
                  <p className="text-gray-400 mb-6" data-id="element-333">{showcase.desc}</p>
                  <button className="text-[#FFD700] font-bold uppercase tracking-widest flex items-center gap-2 group/btn" data-id="element-334">
                    View Live Demo{' '}
                    <ArrowRight className="group-hover/btn:translate-x-2 transition-transform" size={18} data-id="element-335" />
                  </button>
                </div>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 px-6" data-id="element-336">
        <div className="max-w-4xl mx-auto text-center" data-id="element-337">
          <div className="bg-gradient-to-br from-[#FFD700]/20 to-red-600/10 p-12 rounded-3xl border border-[#FFD700]/20 relative overflow-hidden" data-id="element-338">
            <div className="relative z-10 space-y-8" data-id="element-339">
              <h2 className="font-['Archivo_Black'] text-3xl md:text-5xl uppercase leading-tight" data-id="element-340">
                Stop Renting Your Audience.
              </h2>
              <p className="text-xl text-gray-300 font-medium" data-id="element-341">
                Take the Free Creator Audit and get a custom strategy to
                centralize your audience.
              </p>
              <div className="max-w-md mx-auto space-y-4" data-id="element-342">
                <input type="email" placeholder="Enter your email address" className="w-full px-6 py-4 bg-black/40 border border-white/10 rounded-lg focus:outline-none focus:border-[#FFD700] transition-colors font-bold text-center" data-id="element-343" />
                <button className="w-full bg-[#FFD700] text-black py-4 rounded-lg font-bold uppercase tracking-widest hover:bg-white transition-all shadow-xl" data-id="element-344">
                  Get My Free Audit
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>;
}